import React, { useState, useEffect } from 'react';
import Modal from '../../../common/components/Modal/modal';
import KYCImage from '../../../images/icons/KYCComplete.svg';
import { navigate } from 'gatsby';
import { staticData } from 'gatsby-env-variables';
const PropertySuccessPopUP = () => {
  const [show, setShow] = useState('');

  return (
    <React.Fragment>
      <Modal show={true} noCloseBtn={false} setShow={setShow}>
        <div className="w-full  px-4">
          <div className="w-full py-10">
            <p className="font-roboto font-medium mr-auto text text-green-600 text-xl"></p>
          </div>

          <div className="w-full">
            <p className="text-orange-600 font-roboto font-bold py-2">
              Congratulations!
            </p>
            <p className="text-black-400 font-roboto font-normal py-2">
              Your Property Details has been added successfully
            </p>
            <p className="text-black-0 font-roboto font-normal my-4 text-sm">
              Shortly! Your Provisional Sanction Letter will be released
            </p>
            <div className="">
              <img className="mx-auto" src={KYCImage} />
            </div>
            <div className="">
              <button
                className="submitButton"
                onClick={() =>
                  navigate(staticData?.dashboardURl || '/user/home')
                }
              >
                {staticData?.redirectToDashboardDisplay || 'GO TO HOME'}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default PropertySuccessPopUP;
